var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "omegaup-overlay-popup",
    {
      staticClass: "run-submit-popup overlay-popup--wide",
      on: {
        dismiss: function ($event) {
          return _vm.$emit("dismiss")
        },
      },
    },
    [
      _c(
        "form",
        {
          staticClass: "modal-form d-flex flex-column h-100",
          attrs: { "data-run-submit": "" },
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c("div", { staticClass: "form-group row" }, [
            _c("label", { staticClass: "col-sm-2 col-form-label" }, [
              _vm._v(" " + _vm._s(_vm.T.wordsLanguage) + " "),
            ]),
            _c("div", { staticClass: "col-sm-4" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedLanguage,
                      expression: "selectedLanguage",
                    },
                  ],
                  staticClass: "form-control modal-form__control",
                  attrs: { name: "language" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedLanguage = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.allowedLanguages, function (language, key) {
                  return _c("option", { key: key, domProps: { value: key } }, [
                    _vm._v(" " + _vm._s(language) + " "),
                  ])
                }),
                0
              ),
            ]),
          ]),
          _c("div", { staticClass: "form-group row" }, [
            _c(
              "label",
              { staticClass: "col-sm-7 col-form-label" },
              [
                _vm._v(" " + _vm._s(_vm.T.arenaRunSubmitFilename) + " "),
                _c("tt", [_vm._v(_vm._s(_vm.filename))]),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "form-group row" }, [
            _c("label", { staticClass: "col-sm-7 col-form-label" }, [
              _vm._v(_vm._s(_vm.T.arenaRunSubmitPaste)),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "h-100 run-submit-code-view" },
            [
              _c("omegaup-arena-code-view", {
                attrs: { language: _vm.selectedLanguage, readonly: false },
                on: {
                  "change-language": function ($event) {
                    return _vm.handleChangeLanguage($event)
                  },
                },
                model: {
                  value: _vm.code,
                  callback: function ($$v) {
                    _vm.code = $$v
                  },
                  expression: "code",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "form-group row mt-3 align-items-center" }, [
            _c("label", { staticClass: "col-sm-3 col-form-label" }, [
              _vm._v(" " + _vm._s(_vm.T.arenaRunSubmitUpload) + " "),
            ]),
            _c("div", { staticClass: "col-sm-7" }, [
              _c("input", {
                ref: "inputFile",
                staticClass: "w-100 modal-form__control",
                attrs: { type: "file", name: "file" },
              }),
            ]),
          ]),
          _c("div", { staticClass: "form-group row" }, [
            _c("div", { staticClass: "col-sm-10" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "submit",
                    "data-submit-run": "",
                    disabled: !_vm.canSubmit,
                  },
                },
                [
                  !_vm.canSubmit
                    ? _c("omegaup-countdown", {
                        attrs: {
                          "target-time": _vm.nextSubmissionTimestamp,
                          "countdown-format":
                            _vm.omegaup.CountdownFormat
                              .WaitBetweenUploadsSeconds,
                        },
                        on: {
                          finish: function ($event) {
                            _vm.now = Date.now()
                          },
                        },
                      })
                    : _c("span", [_vm._v(_vm._s(_vm.T.wordsSend))]),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }